export default __webpack_public_path__ + "static/media/P314.2.4888d3c8.mp3";